module.exports = __webpack_public_path__ + "static/media/logo_admin_line1.07874be2.png";